import { SerializedVehicleReport } from '@ltvco/refresh-lib/v1';
import { VehicleValue } from '@ltvco/refresh-lib/v2';

interface VehicleValueSectionProps {
  vehicleReport: SerializedVehicleReport;
}

export const VehicleValueSection = ({
  vehicleReport,
}: VehicleValueSectionProps) => {
  return <VehicleValue vehicleReport={vehicleReport} />;
};
